import axios from "axios";

export const state = {
    staffloads: [],
};

export const getters = {
    staffloads: state => state.staffloads,
};

export const mutations = {
    setStaffLoad(state, newValue) {
        state.staffloads = newValue
    },
};

export const actions = {
    fetchStaffLoads({ commit }) {
        axios.get('/staffloads').then(res => {
            commit('setStaffLoad', res.data.staffloads);
        })
    },
};
